import React, { useState, useRef } from "react";
import PolaroidStyleItemUnitView from "presentational/common/itemUnit/polaroidStyle/PolaroidStyleItemUnitView";
import { getDeviceType } from "lib/deviceInfo";
import BrowserResizeDetector from "presentational/common/BrowserResizeDetector";
import config from "lib/fr-config";
import styles from "./PolaroidStyleItemListView.scss";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import { useEffect } from "react";

const cx = classNames.bind(styles);

PolaroidStyleItemListView.propTypes = {
  itemList: PropTypes.array.isRequired,
  onItemClick: PropTypes.func.isRequired,

  markedList: PropTypes.array,
  deleteMode: PropTypes.bool,
  displayItemUnitTooltip: PropTypes.bool
};

PolaroidStyleItemListView.defaultProps = {
  markedList: null,
  deleteMode: false,
  displayItemUnitTooltip: false
};

function PolaroidStyleItemListView(props) {
  const {
    itemList,
    onItemClick,
    markedList,
    deleteMode,
    displayItemUnitTooltip
  } = props;
  const [numOfUnitsPerRow, setNumOfUnitsPerRow] = useState(0);
  const [hasClickedItemUnitAtLeastOnce, setHasClickedItemUnitAtLeastOnce] =
    useState(false);

  const hiddenContainer = useRef();

  useEffect(() => {
    updateNumOfUnitPerRow();
  });

  const getCss = () => {
    const { rightMarginRatio, bottomMarginRatio } =
      getCssValueOfUnitByDeviceType();
    const unitWidthPercent =
      numOfUnitsPerRow === 0
        ? 0
        : 100 / (numOfUnitsPerRow * (1 + rightMarginRatio) - rightMarginRatio);

    return {
      unit: {
        width: `${unitWidthPercent}%`,
        marginBottom: `${unitWidthPercent * bottomMarginRatio}%`
      }
    };
  };

  const handleItemClick = itemInfo => {
    setHasClickedItemUnitAtLeastOnce(true);
    onItemClick(itemInfo);
  };

  const getCssValueOfUnitByDeviceType = () => {
    const deviceType = getDeviceType();
    const minWidthOfThumbnail =
      config.itemImage.MINIMUM_WIDTH_OF_THUMBNAIL[deviceType];
    const {
      rightMarginProportionToImageWidth: rightMarginRatio,
      bottomMarginProportionToImageWidth: bottomMarginRatio
    } = config.css[deviceType].itemUnit;

    return { minWidthOfThumbnail, rightMarginRatio, bottomMarginRatio };
  };

  const getNumOfUnitPerRow = () => {
    const { minWidthOfThumbnail, rightMarginRatio } =
      getCssValueOfUnitByDeviceType();
    const widthOfRoot = hiddenContainer.current.clientWidth;
    const rightPadding = minWidthOfThumbnail * rightMarginRatio;

    if (widthOfRoot === 0) {
      return -1;
    } else {
      const maxNum = Math.floor(
        (widthOfRoot + rightPadding) / (minWidthOfThumbnail + rightPadding)
      );
      return maxNum < 1 ? 1 : maxNum;
    }
  };

  const updateNumOfUnitPerRow = () => {
    const newNum = getNumOfUnitPerRow();
    if (newNum === -1) return null;

    if (numOfUnitsPerRow !== newNum) {
      setNumOfUnitsPerRow(newNum);
    }
  };

  const isMarkedUnit = itemInfo => {
    if (!markedList || markedList.length === 0 || !itemInfo) return false;

    for (let i = 0; i < markedList.length; i++) {
      const markedItemInfo = markedList[i];
      if (markedItemInfo.itemHash === itemInfo.itemHash) return true;
    }
    return false;
  };

  const handleResize = () => {
    updateNumOfUnitPerRow();
  };

  const getUnit = (item, countNum) => {
    const css = getCss();

    return (
      <div className={cx("image-wrapper")} style={css.unit} key={countNum}>
        <PolaroidStyleItemUnitView
          onClick={handleItemClick}
          isMarkedItem={isMarkedUnit(item)}
          itemInfo={item}
          deleteMode={deleteMode}
          isFirstUnit={countNum === 0}
          displayItemUnitTooltip={displayItemUnitTooltip}
          hasClickedItemUnitAtLeastOnce={hasClickedItemUnitAtLeastOnce}
        />
      </div>
    );
  };

  const getUnitList = () => {
    const returnListArr = [];
    if (numOfUnitsPerRow === 0) return returnListArr;

    for (let i = 0; i < itemList.length; i = i + numOfUnitsPerRow) {
      const oneLineArr = [];
      for (let countNum = i; countNum < i + numOfUnitsPerRow; countNum++) {
        const item = itemList[countNum];
        const oneUnit = getUnit(item, countNum);

        if (item) {
          oneLineArr.push(oneUnit);
        } else {
          oneLineArr.unshift(oneUnit);
        }
      }

      returnListArr.push(
        <div className={cx("image-row")} key={i}>
          {oneLineArr}
        </div>
      );
    }

    return returnListArr;
  };

  return (
    <div>
      <div style={{ width: "100%" }} ref={hiddenContainer}></div>
      <BrowserResizeDetector onResize={handleResize} />
      {getUnitList()}
    </div>
  );
}

export default PolaroidStyleItemListView;
